<template>
  <div class="rview">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;700&family=IBM+Plex+Sans:ital,wght@0,100;0,500;0,600;0,700;1,100;1,700&family=IBM+Plex+Serif:ital,wght@0,100;0,300;0,400;0,500;0,700;1,100;1,200;1,500;1,700&display=swap');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

#app {
  font-family: "IBM Plex Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #5b6c79;
  margin-top: 6px;
}

.rview {
  display: flex;
  align-items: center;
  justify-content: center;
  width:calc(100% - 6px);
  min-height:calc(100% - 6px);
  margin: 3px;
}

.material-icon {
  font-family: "Material Icons",sans-serif;
}
</style>
